import React, { useEffect } from "react";
import { Header } from "../../../components/header/Header";
import { RiArrowRightUpFill } from "react-icons/ri";

import userImage from "../../../assets/user.svg"
import artistImage from "../../../assets/artist_image.svg"
import dollarIcon from "../../../assets/dollar_icon.svg"
import colorIcon from "../../../assets/color_icon.svg"

import { Link } from "react-router-dom";
import ArtistComponent from "../../dashboard-components/ArtistComponent";
import ArtistParticipateContestComponent from "../../dashboard-components/ArtistParticipateContestComponent";
import { createSelector } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { getAdminStatThunk as onGetAdminStatThunk } from "../../../slices/users/thunk";

export const AdminHome = () => {

    const dispatch = useDispatch();
    const selecDashboardState = (state) => state.user;
    const contestSelector = createSelector(selecDashboardState, (artist) => ({
    isLoading: artist.isLoading,
    adminDashboard: artist.adminDashboard,
  }));

  const { adminDashboard, isLoading } = useSelector(contestSelector);

    useEffect(() => {
      dispatch(onGetAdminStatThunk({ userType: 2 }));
    }, [dispatch]);


    const stats = [
    {
      id: 1,
      title: "Users",
      value: isLoading ? "..." : (adminDashboard?.totalUsers ?? 0),
      percent: "+15%",
      icon: userImage,
      linkText: "View More",
      link:'/admin/users'
    },
    {
      id: 2,
      title: "Artists",
      value: isLoading ? "..." : (adminDashboard?.totalArtist ?? 0),
      percent: "+15%",
      icon: artistImage,
      linkText: "View More",
      link:'/admin/artists'
    },
    {
      id: 3,
      title: "Total Revenue",
      value: isLoading ? "..." : `$${Number(adminDashboard?.totalRevenue ?? 0).toFixed(2)}`,
      percent: "+15%",
      icon: dollarIcon,
      linkText: "View More",
      link:'/admin/revenue'
    },
    {
      id: 4,
      title: "Total Artwork",
      value: isLoading ? "..." : (adminDashboard?.totalArtwork ?? 0),
      percent: "+15%",
      icon: colorIcon,
      linkText: "View More",
      link:'/admin/contests/0'
    },
  ];

  // Skeleton stat card shown while admin dashboard is loading
  const SkeletonStatCard = () => (
    <div className="w-full flex items-center justify-between border border-border_color rounded-[20px] p-6 bg-white animate-pulse">
      {/* Left Side skeleton */}
      <div className="flex flex-col">
        <div className="h-4 w-24 bg-gray-200 rounded" />
        <div className="h-8 w-28 bg-gray-200 rounded mt-2" />
        <div className="flex items-center gap-1 mt-2">
          <div className="w-[18px] h-[18px] bg-gray-300 rounded-full" />
          <div className="h-4 w-12 bg-gray-200 rounded" />
        </div>
      </div>

      {/* Right Side skeleton */}
      <div className="flex flex-col items-end gap-9">
        <div className="w-8 h-8 bg-gray-200 rounded" />
        <div className="h-4 w-20 bg-gray-200 rounded" />
      </div>
    </div>
  );


    return (
        <>

            <header className="fixed top-0 left-0 md:left-[205px] md:w-[calc(100%-205px)] z-40 bg-white w-full h-14 md:h-[84px] flex items-center justify-center px-4 sm:px-[51px] border-b border-border_color ">
                {/* Header */}
                <Header name={"Sanan"} />
            </header>
            <div className="w-full   mx-auto bg-[#F7F7F7]">

                {/* Items */}
                <div className="w-full mt-6">
                    <div className="w-full mx-auto grid gap-7 grid-cols-1 xs:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4  justify-items-center">
                        {isLoading
                          ? Array.from({ length: 4 }).map((_, idx) => (
                              <SkeletonStatCard key={idx} />
                            ))
                          : stats.map((item) => (
                              <div
                                key={item.id}
                                className="w-full  flex items-center justify-between border border-border_color rounded-[20px] p-6 bg-white"
                              >
                                {/* Left Side */}
                                <div className="flex flex-col">
                                  <span className="font-grotesk font-medium text-[14px] text-[#797D8C]">
                                    {item.title}
                                  </span>
                                  <span className="font-grotesk font-bold text-[32px] text-[#242424]">
                                    {item.value}
                                  </span>
                                  <div className="flex items-center gap-1">
                                    <div className="w-[18px] h-[18px] bg-primary rounded-full flex items-center justify-center">
                                      <RiArrowRightUpFill className="text-white font-bold" />
                                    </div>
                                    <span className="font-grotesk font-bold text-[14px] text-primary">
                                      {item.percent}
                                    </span>
                                  </div>
                                </div>

                                {/* Right Side */}
                                <div className="flex flex-col items-end gap-9">
                                  <div className="w-8 h-8 overflow-hidden">
                                    <img
                                      src={item.icon}
                                      alt={item.title}
                                      className="w-full h-full object-contain"
                                    />
                                  </div>
                                  <div>
                                    <Link
                                      to={item.link}
                                      className="block text-xs text-secondary font-medium font-grotesk underline"
                                    >
                                      {item.linkText}
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            ))}
                    </div>
                </div>
                {/* Table */}
                <div className="w-full flex items-start justify-between flex-col xl:flex-row mt-8 gap-5 mb-5">
                    {/* Right */}
                <ArtistParticipateContestComponent artistId={0}/>
                    {/* Left Side */}
                  <ArtistComponent/>


                </div>
            </div>
        </>
    );
};

